// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Per-mood color identity.
   Applied via [data-mood] on <html> by MoodProvider (src/theme/MoodContext.jsx).
   Imported after Colors.css so these override the neutral defaults.

   Each mood defines:
     --mood-accent   interactive accent (buttons, active states, links)
     --mood-glow-1/2/3  the three blurred blobs in AmbientBackdrop
     --mood-tint     a wash laid over --bg-base for the whole page
     --mood-halo     radial fill behind illustrations */

:root,
[data-mood='neutral'] {
  --mood-accent: #6FD8C8;
  --mood-glow-1: rgba(46, 143, 168, 0.28);
  --mood-glow-2: rgba(31, 111, 106, 0.22);
  --mood-glow-3: rgba(90, 95, 168, 0.14);
  --mood-tint: rgba(24, 40, 44, 0.5);
  --mood-halo: rgba(111, 216, 200, 0.16);
}

[data-mood='morning'] {
  --mood-accent: #FFB765;
  --mood-glow-1: rgba(245, 161, 91, 0.42);
  --mood-glow-2: rgba(232, 115, 122, 0.32);
  --mood-glow-3: rgba(31, 111, 106, 0.26);
  --mood-tint: rgba(58, 34, 22, 0.62);
  --mood-halo: rgba(255, 183, 101, 0.22);
}

[data-mood='night'] {
  --mood-accent: #8FA8FF;
  --mood-glow-1: rgba(59, 75, 158, 0.5);
  --mood-glow-2: rgba(91, 62, 142, 0.38);
  --mood-glow-3: rgba(20, 80, 92, 0.3);
  --mood-tint: rgba(16, 20, 48, 0.68);
  --mood-halo: rgba(143, 168, 255, 0.2);
}

[data-mood='active'] {
  --mood-accent: #63E0A6;
  --mood-glow-1: rgba(31, 158, 107, 0.42);
  --mood-glow-2: rgba(79, 212, 138, 0.26);
  --mood-glow-3: rgba(28, 106, 120, 0.3);
  --mood-tint: rgba(16, 44, 36, 0.62);
  --mood-halo: rgba(99, 224, 166, 0.2);
}

[data-mood='focus'] {
  --mood-accent: #9BA8FF;
  --mood-glow-1: rgba(90, 95, 168, 0.42);
  --mood-glow-2: rgba(53, 80, 127, 0.36);
  --mood-glow-3: rgba(38, 42, 62, 0.5);
  --mood-tint: rgba(22, 26, 44, 0.64);
  --mood-halo: rgba(155, 168, 255, 0.18);
}

[data-mood='sun'] {
  --mood-accent: #FFD166;
  --mood-glow-1: rgba(240, 169, 59, 0.44);
  --mood-glow-2: rgba(47, 163, 184, 0.34);
  --mood-glow-3: rgba(255, 209, 102, 0.2);
  --mood-tint: rgba(56, 42, 18, 0.6);
  --mood-halo: rgba(255, 209, 102, 0.22);
}

[data-mood='nightout'] {
  --mood-accent: #FF8FC5;
  --mood-glow-1: rgba(194, 65, 138, 0.42);
  --mood-glow-2: rgba(107, 46, 122, 0.42);
  --mood-glow-3: rgba(41, 34, 66, 0.5);
  --mood-tint: rgba(38, 18, 40, 0.66);
  --mood-halo: rgba(255, 143, 197, 0.2);
}

[data-mood='cabinet'],
[data-mood='add'] {
  --mood-accent: #7FD6E8;
  --mood-glow-1: rgba(46, 143, 168, 0.36);
  --mood-glow-2: rgba(31, 111, 106, 0.28);
  --mood-glow-3: rgba(127, 214, 232, 0.16);
  --mood-tint: rgba(18, 38, 46, 0.58);
  --mood-halo: rgba(127, 214, 232, 0.2);
}

[data-mood='custom'] {
  --mood-accent: #8FE0D2;
  --mood-glow-1: rgba(46, 143, 168, 0.34);
  --mood-glow-2: rgba(90, 95, 168, 0.26);
  --mood-glow-3: rgba(31, 111, 106, 0.26);
  --mood-tint: rgba(20, 38, 44, 0.58);
  --mood-halo: rgba(143, 224, 210, 0.18);
}
`, "",{"version":3,"sources":["webpack://./src/styles/moods.css"],"names":[],"mappings":"AAAA;;;;;;;;uDAQuD;;AAEvD;;EAEE,sBAAsB;EACtB,uCAAuC;EACvC,uCAAuC;EACvC,sCAAsC;EACtC,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,uCAAuC;EACvC,wCAAwC;EACxC,uCAAuC;EACvC,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,sCAAsC;EACtC,oCAAoC;EACpC,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,uCAAuC;EACvC,uCAAuC;EACvC,sCAAsC;EACtC,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,sCAAsC;EACtC,oCAAoC;EACpC,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,uCAAuC;EACvC,uCAAuC;EACvC,oCAAoC;EACpC,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;;EAEE,sBAAsB;EACtB,uCAAuC;EACvC,uCAAuC;EACvC,wCAAwC;EACxC,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,uCAAuC;EACvC,sCAAsC;EACtC,uCAAuC;EACvC,mCAAmC;EACnC,sCAAsC;AACxC","sourcesContent":["/* Per-mood color identity.\n   Applied via [data-mood] on <html> by MoodProvider (src/theme/MoodContext.jsx).\n   Imported after Colors.css so these override the neutral defaults.\n\n   Each mood defines:\n     --mood-accent   interactive accent (buttons, active states, links)\n     --mood-glow-1/2/3  the three blurred blobs in AmbientBackdrop\n     --mood-tint     a wash laid over --bg-base for the whole page\n     --mood-halo     radial fill behind illustrations */\n\n:root,\n[data-mood='neutral'] {\n  --mood-accent: #6FD8C8;\n  --mood-glow-1: rgba(46, 143, 168, 0.28);\n  --mood-glow-2: rgba(31, 111, 106, 0.22);\n  --mood-glow-3: rgba(90, 95, 168, 0.14);\n  --mood-tint: rgba(24, 40, 44, 0.5);\n  --mood-halo: rgba(111, 216, 200, 0.16);\n}\n\n[data-mood='morning'] {\n  --mood-accent: #FFB765;\n  --mood-glow-1: rgba(245, 161, 91, 0.42);\n  --mood-glow-2: rgba(232, 115, 122, 0.32);\n  --mood-glow-3: rgba(31, 111, 106, 0.26);\n  --mood-tint: rgba(58, 34, 22, 0.62);\n  --mood-halo: rgba(255, 183, 101, 0.22);\n}\n\n[data-mood='night'] {\n  --mood-accent: #8FA8FF;\n  --mood-glow-1: rgba(59, 75, 158, 0.5);\n  --mood-glow-2: rgba(91, 62, 142, 0.38);\n  --mood-glow-3: rgba(20, 80, 92, 0.3);\n  --mood-tint: rgba(16, 20, 48, 0.68);\n  --mood-halo: rgba(143, 168, 255, 0.2);\n}\n\n[data-mood='active'] {\n  --mood-accent: #63E0A6;\n  --mood-glow-1: rgba(31, 158, 107, 0.42);\n  --mood-glow-2: rgba(79, 212, 138, 0.26);\n  --mood-glow-3: rgba(28, 106, 120, 0.3);\n  --mood-tint: rgba(16, 44, 36, 0.62);\n  --mood-halo: rgba(99, 224, 166, 0.2);\n}\n\n[data-mood='focus'] {\n  --mood-accent: #9BA8FF;\n  --mood-glow-1: rgba(90, 95, 168, 0.42);\n  --mood-glow-2: rgba(53, 80, 127, 0.36);\n  --mood-glow-3: rgba(38, 42, 62, 0.5);\n  --mood-tint: rgba(22, 26, 44, 0.64);\n  --mood-halo: rgba(155, 168, 255, 0.18);\n}\n\n[data-mood='sun'] {\n  --mood-accent: #FFD166;\n  --mood-glow-1: rgba(240, 169, 59, 0.44);\n  --mood-glow-2: rgba(47, 163, 184, 0.34);\n  --mood-glow-3: rgba(255, 209, 102, 0.2);\n  --mood-tint: rgba(56, 42, 18, 0.6);\n  --mood-halo: rgba(255, 209, 102, 0.22);\n}\n\n[data-mood='nightout'] {\n  --mood-accent: #FF8FC5;\n  --mood-glow-1: rgba(194, 65, 138, 0.42);\n  --mood-glow-2: rgba(107, 46, 122, 0.42);\n  --mood-glow-3: rgba(41, 34, 66, 0.5);\n  --mood-tint: rgba(38, 18, 40, 0.66);\n  --mood-halo: rgba(255, 143, 197, 0.2);\n}\n\n[data-mood='cabinet'],\n[data-mood='add'] {\n  --mood-accent: #7FD6E8;\n  --mood-glow-1: rgba(46, 143, 168, 0.36);\n  --mood-glow-2: rgba(31, 111, 106, 0.28);\n  --mood-glow-3: rgba(127, 214, 232, 0.16);\n  --mood-tint: rgba(18, 38, 46, 0.58);\n  --mood-halo: rgba(127, 214, 232, 0.2);\n}\n\n[data-mood='custom'] {\n  --mood-accent: #8FE0D2;\n  --mood-glow-1: rgba(46, 143, 168, 0.34);\n  --mood-glow-2: rgba(90, 95, 168, 0.26);\n  --mood-glow-3: rgba(31, 111, 106, 0.26);\n  --mood-tint: rgba(20, 38, 44, 0.58);\n  --mood-halo: rgba(143, 224, 210, 0.18);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
